import React, { } from 'react'

import { useSelector } from 'react-redux'

import { withRouter } from 'react-router-dom'

import SourceIcon from '../tools/SourceIcon'
import { QuarantineSubBanner } from '../tools'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'

import Button from '@material-ui/core/Button'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Grid from '@material-ui/core/Grid'
import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'

import { withStyles, makeStyles } from '@material-ui/core/styles'

import { truncateText } from '../../../utils'
import { Avatar } from '@material-ui/core'
import FlagIcon from '@material-ui/icons/Flag'
import { toggleImage } from '../../../utils/functions/toggleFunctions'

const useStyles = makeStyles((theme) => ({
  listImg: {
    width: '100%',
    margin: 'auto 0',
    backgroundSize: 'contain',
    height: '100%'
  },
  violationCard: {
    width: '95%',
    backgroundColor: '#e7e6e9'
  },
  newCapture: {
    borderBottom: '10px solid #CB9BFF'
  },
  problemCapture: {
    borderBottom: '10px solid #FFA593'
  },
  noProblemCapture: {
    borderBottom: '10px solid #96E1A8'
  },
  holdCapture: {
    borderBottom: '10px solid #FFFF91'
  },
  solvedCapture: {
    borderBottom: '10px solid #A6FFFF'
  },
  changedCapture: {
    borderBottom: '10px solid #ffa500'
  },
  violationContainer: {
    height: 'auto'
  },
  imageContainer: {
    // height: '100%'
  },
  infoContainer: {
    height: '100%'
  },
  smallDesc: {
    fontSize: '1em'
  },
  hideContent: {
    visibility: 'hidden',
    width: '90%'
  },
  flagContainer: {
    position: 'absolute',
    pointerEvents: 'none'
  },
  flagAvatar: {
    backgroundColor: theme.palette.error.light
  }
}))

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 12,
    leavTouchDelay: 10000
  }
}))(Tooltip)

const InactiveListView = (props) => {
  const { capture, handleQuickFilter, getSourceDescription, shouldRender } = props
  const classes = useStyles()

  const Flags = useSelector(state => state.violations.violations.flags)
  const isFlagged = Flags ? Flags.findIndex((flagInfo) => flagInfo.violationID === capture?.violationID) !== -1 : false

  const getSeverityColor = (severity) => {
    if (severity > 0 && severity <= 20) {
      return '#5291fc'
    } else if (severity > 20 && severity <= 40) {
      return '#4e179a'
    } else if (severity > 40 && severity <= 60) {
      return '#f5d818'
    } else if (severity > 60 && severity <= 80) {
      return '#e7840f'
    } else {
      return '#d31111'
    }
  }

  const iconOptions = {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: 18,
    leaveTouchDelay: 10000
  }

  const getCardFlag = (text) => {
    switch (text) {
      case 'U':
        return classes.newCapture
      case 'P':
        return classes.problemCapture
      case 'N':
        return classes.noProblemCapture
      case 'H':
        return classes.holdCapture
      case 'S':
        return classes.solvedCapture
      case 'C':
        return classes.changedCapture
      default:
        return ''
    }
  }

  return (
    <>
      {shouldRender && isFlagged &&
        <Grid container direction='row' className={classes.flagContainer}>
          <Avatar variant='rounded' className={classes.flagAvatar}>
            <FlagIcon />
          </Avatar>
        </Grid>}
      <Card className={`${getCardFlag(capture?.statusFlag)} ${!shouldRender ? classes.hideContent : classes.violationCard}`} raised>
        <Grid container direction='row' className={classes.violationContainer}>
          <Grid item xs={3} container direction='column' className={classes.imageContainer} justify='center'>
            <Grid item container>
              {toggleImage(capture, false, null, classes.listImg)}
            </Grid>
            {capture?.quarantined && <QuarantineSubBanner redacted={capture?.redacted} fontSize={10} height={40} />}
          </Grid>
          <Grid item xs={7} container direction='row' className={classes.infoContainer}>
            <CardContent className='w-100 p-0'>
              <List disablePadding className='my-auto'>
                <ListItem dense>
                  <Grid container direction='row' spacing={2} className='w-100 mx-auto'>
                    <Grid item container direction='row' alignItems='center'>
                      <Grid item>
                        <Typography variant='h6' className={`font-weight-bold ${classes.smallDesc}`}>Username:</Typography>
                      </Grid>

                      <Grid item>
                        <Button
                          variant='text'
                          size='small'
                          color='primary'
                          onClick={() => { handleQuickFilter({ username: capture?.username }) }}
                        >
                          {capture?.userDisplayName || capture?.username || 'N/A'}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </ListItem>

                <ListItem dense>
                  <Grid container direction='row' spacing={2} className='w-100 mx-auto'>
                    <Grid item xs={6} container direction='row' alignItems='center'>
                      <Grid item>
                        <Typography variant='h6' className={`font-weight-bold ${classes.smallDesc}`}>Category:</Typography>
                      </Grid>

                      <Grid item>
                        <Button
                          variant='outlined'
                          color='primary'
                          size='small'
                          onClick={(e) => { e.preventDefault(); handleQuickFilter({ categoryName: capture?.categoryName }) }}
                        >
                          {capture?.categoryName || 'N/A'}
                        </Button>
                      </Grid>
                    </Grid>

                    <Grid item xs={6} container direction='row' alignItems='center'>
                      <Grid item>
                        <Typography variant='h6' className={`font-weight-bold ${classes.smallDesc}`}>Phrase:</Typography>
                      </Grid>

                      <Grid item>
                        <Button
                          variant='outlined'
                          color='primary'
                          size='small'
                          onClick={() => { handleQuickFilter({ phrase: capture?.phrase }) }}
                        >
                          {capture?.multiple_phrases ? `${capture?.phrase} *` : capture?.phrase || 'N/A'}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </ListItem>

                <ListItem dense>
                  <Grid container direction='row' spacing={2} className='w-100 mx-auto'>
                    <Grid item xs={6} container direction='row' alignItems='center'>
                      <Grid item>
                        <Typography variant='h6' className={`font-weight-bold ${classes.smallDesc}`}>Station:</Typography>
                      </Grid>

                      <Grid item>
                        <Button
                          variant='text'
                          color='primary'
                          size='small'
                          onClick={() => { handleQuickFilter({ workstationName: capture?.workstationName }) }}
                        >
                          {capture?.workstationName.substring(0, 10) || 'N/A'}
                        </Button>
                      </Grid>
                    </Grid>

                    <Grid item xs={6} container direction='row' alignItems='center'>
                      <Grid item>
                        <Typography variant='h6' className={`font-weight-bold ${classes.smallDesc}`}>IP ADDR:</Typography>
                      </Grid>

                      <Grid item>
                        <Typography>{capture?.station_ip || '0.0.0.0'}</Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </ListItem>

                <ListItem dense>
                  <Grid container direction='row' spacing={2} className='w-100 mx-auto'>
                    <Grid item xs={6} container direction='row' alignItems='center'>
                      <Grid item>
                        <Typography variant='h6' className={`font-weight-bold ${classes.smallDesc}`}>Source:</Typography>
                      </Grid>
                      <Grid item>
                        {SourceIcon(getSourceDescription(capture?.source), handleQuickFilter, iconOptions, 35)}
                      </Grid>
                    </Grid>

                    <Grid item xs={6} container direction='row' alignItems='center'>
                      <Grid item>
                        <Typography variant='h6' className={`font-weight-bold ${classes.smallDesc}`}>Application:</Typography>
                      </Grid>
                      <Grid item>
                        <LightTooltip title={capture?.applicationName} placement='right'>
                          <Button
                            color='primary'
                            variant='text'
                            size='small'
                            onClick={(e) => { handleQuickFilter({ applicationName: capture?.applicationName }) }}
                          >
                            {truncateText((`${capture?.applicationName ? capture?.applicationName : 'N/A'}`))}
                          </Button>
                        </LightTooltip>
                      </Grid>
                    </Grid>
                  </Grid>
                </ListItem>

              </List>
            </CardContent>
          </Grid>
          <Grid item container direction='column' xs={2} className='severityBanner'>
            <Grid item>
              <Paper id='severity-badge-list' elevation={1} color='primary' style={{ backgroundColor: getSeverityColor(capture?.severity), color: '#FFFFFF' }}>{capture?.severity}</Paper>
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </>
  )
}

export default withRouter(InactiveListView)
